import { Avatar, Box, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useSelector } from 'react-redux';
const Brands = ({ brands, handleId, userId }) => {
    const {isScreenZoomed} = useSelector(state=>state.commonSlice);
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 4,
            slidesToSlide: 4,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: isScreenZoomed ? 4 : 5,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: isScreenZoomed ? 4 : 5,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
    };
    return (
        <>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
                <Typography fontSize={20} fontWeight={600} color={"black"}>Brands</Typography>
                {brands?.length > 0 && handleId > 0 && <a href={`/`} onClick={(e) => {
                    e.preventDefault();
                    window.open(`/user-brands/${handleId}/${userId}`, "_blank")
                }} style={{ fontSize: 16, fontWeight: 400, color: '#7209B7', textDecoration: "none" }}> View All</a>}
            </Stack>
            <div className='secItem' style={{ marginTop: 30 }}>
                <div className='row g-3'>
                    {brands?.length > 0 ? <Carousel responsive={responsive} itemClass="carousel-item-padding-40-px">
                        {brands?.map((v) => {
                            return (
                                <Stack direction={"column"} justifyContent={"space-between"} alignItems={"center"} sx={{ width: '260px', padding: '20px 40px', border: '1px solid #EEE', borderRadius: '8px' }}>
                                    {console.log(v, 'brands')}
                                    <Avatar src={v.image} alt={v.image} sx={{ height: '60px', width: '60px', marginBottom: '20px' }} />
                                    <Box sx={{ marginBottom: '40px', textAlign: 'center' }}>
                                        <Typography fontSize={16} fontWeight={600} color={'black'}>{v.Name}</Typography>
                                        <Typography fontSize={14} fontWeight={400} color={'#AAA'}>@{v.socialHandleName}</Typography>
                                    </Box>
                                    <Typography fontSize={14} fontWeight={400} color={'#AAA'} >{v.media_count} Post</Typography>
                                </Stack>
                            )
                        })}
                    </Carousel> : <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-3 col-sm-4 col-6">
                        <div className="brandBlocks brandBlImg">No Data Found</div>
                    </div>}
                </div>
            </div>
        </>
    )
}
export default Brands;